import * as React from 'react';

function SvgPaymentMastercard(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={78} height={50} viewBox="0 0 78 50" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          fill="#A4A4AD"
          d="M5.77 0h66.46c2 0 2.73.2 3.47.6.73.4 1.3.97 1.7 1.7.4.74.6 1.46.6 3.47v38.46c0 2-.2 2.73-.6 3.47-.4.73-.97 1.3-1.7 1.7-.74.4-1.46.6-3.47.6H5.77c-2 0-2.73-.2-3.47-.6-.73-.4-1.3-.97-1.7-1.7-.4-.74-.6-1.46-.6-3.47V5.77c0-2 .2-2.73.6-3.47C1 1.57 1.57 1 2.3.6 3.04.2 3.76 0 5.77 0z"
        />
        <path
          fill="#FFF"
          d="M5.99 1.5H72c1.56 0 2.13.16 2.7.47.57.3 1.02.75 1.32 1.32.3.57.47 1.14.47 2.7V44c0 1.56-.16 2.13-.47 2.7-.3.57-.75 1.02-1.32 1.32-.57.3-1.14.47-2.7.47H6c-1.56 0-2.13-.16-2.7-.47a3.18 3.18 0 01-1.32-1.32c-.3-.57-.47-1.14-.47-2.7V6c0-1.56.16-2.13.47-2.7.3-.57.75-1.02 1.32-1.32.57-.3 1.14-.47 2.7-.47z"
        />
        <circle
          cx={30.5}
          cy={24.5}
          r={12.5}
          fill="red"
          fillRule="nonzero"
          opacity={0.75}
        />
        <circle
          cx={47.5}
          cy={24.5}
          r={12.5}
          fill="#FFB800"
          fillRule="nonzero"
          opacity={0.75}
        />
      </g>
    </svg>
  );
}

export default SvgPaymentMastercard;
